import {
	Cross2Icon,
	ExclamationTriangleIcon,
	InfoCircledIcon,
} from "@radix-ui/react-icons"

import styles from "./ErrorNotification.module.scss"

import type { NotificationItem } from "./types"

export function ExpandedList({
	notifications,
	onDismiss,
	onClearAll,
}: {
	notifications: NotificationItem[]
	onDismiss: (id: string) => void
	onClearAll: () => void
}) {
	return (
		<div className={styles.expandedPanel}>
			<div className={styles.expandedHeader}>
				<div className={styles.expandedHeaderLeft}>
					<span className={styles.expandedTitle}>通知</span>
					<span className={styles.badge}>{notifications.length}</span>
				</div>
				<button
					className={styles.panelCloseButton}
					onClick={onClearAll}
					aria-label="すべて消去"
				>
					<Cross2Icon width={16} height={16} />
				</button>
			</div>
			<div className={styles.expandedList}>
				{notifications.map((notification) => {
					const isInfo = notification.kind === "info"
					return (
						<div key={notification.id} className={styles.expandedItem}>
							<div
								className={`${styles.itemIcon} ${isInfo ? styles.itemIconInfo : ""}`}
							>
								{isInfo ? (
									<InfoCircledIcon width={16} height={16} />
								) : (
									<ExclamationTriangleIcon width={16} height={16} />
								)}
							</div>
							<div className={styles.itemContent}>
								<div className={styles.itemMessage}>{notification.message}</div>
							</div>
							<button
								className={styles.dismissButton}
								onClick={() => onDismiss(notification.id)}
								aria-label="削除"
							>
								<Cross2Icon width={14} height={14} />
							</button>
						</div>
					)
				})}
			</div>
		</div>
	)
}
